PegasusTemplate.computed = {
  t: function( translationKey ) {
    return Em.computed( function(){
      return Em.I18n.t( translationKey );
    }).cacheable();
  },

  nearestViewOfType: function( type ) {
    return Ember.computed(function(){
      for( var view = this.get('parentView'); view; view = view.get('parentView')){
        if( Ember.get(type).detectInstance( view ) ){
          return view;
        }
      }
    }).volatile();
  },

  nearestViewOfTypes: function( types ) {
    var type;
    return Ember.computed(function(){
      for (var i = 0; i < types.length; i++){
        type = types[i];
        for( var view = this.get('parentView'); view; view = view.get('parentView')){
          if( Ember.get(type).detectInstance( view ) ){
            return view;
          }
        }
      }
    }).volatile();
  },

  t: function( translationKey ) {
    return Em.computed( function(){
      return Em.I18n.t( translationKey );
    }).cacheable();
  },

  nearestProperty: function( prop ) {
    return Ember.computed(function(){
      for( var view = this.get('parentView'); view; view = view.get('parentView')){
        if( view.hasOwnProperty( prop ) ){
          return view.get(prop);
        }
      }
    }).volatile();
  },

  withinRange: function(dependentKey, low, high){
    return Ember.computed( dependentKey, function(){
      return this.get( dependentKey ) > low &&
        this.get( dependentKey ) < high;
    });
  }
};
